import { render, staticRenderFns } from "./DetaliiCerere.vue?vue&type=template&id=79c76a58&scoped=true"
import script from "./DetaliiCerere.vue?vue&type=script&lang=js"
export * from "./DetaliiCerere.vue?vue&type=script&lang=js"
import style0 from "./DetaliiCerere.vue?vue&type=style&index=0&id=79c76a58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c76a58",
  null
  
)

export default component.exports